<template>
  <div class="bar-options-setting-dialog" ref="barSetting">
    <el-collapse v-model="sizeActiveNames">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
      <el-collapse-item name="2" class="paddingtb8">
        <template slot="title">
          <div class="tabs flex" :class="request_prefix === 'bigScreen' ? '' : 'home_tabs'">
            <div :class="tabsActive == 0 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 0)">
              数据组
            </div>
            <div :class="tabsActive == 1 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 1)">
              图例
            </div>
          </div>
        </template>
        <div class="setting-item">
          <template v-if="tabsActive == 0">
            <numberSetting :options="options" :ids="ids"></numberSetting>
            <scrollSetting :options="options" :ids="ids"></scrollSetting>
            <div v-for="(item, index) in seriesData" :key="index">
              <collapsibleItem
                :key="index"
                :name="'data' + index"
                :type="item.name"
                :is-active="collapse[item.name].isActive"
                @collapsibleItemClick="collapsibleItemClickHandle($event, index)"
              >
                <div slot="heading">{{ item.name }}</div>
                <div slot="body">
                  <component
                    :is="item.type[0].toUpperCase() + item.type.slice(1) + 'SeriesSetting'"
                    :seriesSettingItem="item"
                    :seriesDataLen="seriesData.length"
                    :ids="ids"
                    :index="index"
                    :options="options"
                    ref="seriesSetting"
                  ></component>
                </div>
              </collapsibleItem>
            </div>
          </template>
          <template v-else>
            <legend-setting :options="options" :ids="ids"></legend-setting>
          </template>
        </div>
      </el-collapse-item>
    </el-collapse>
    <chart-common-options-setting :options="options" :ids="ids"></chart-common-options-setting>
  </div>
</template>

<script>
import legendSetting from "toolbarComponents/bigScreen/common/options/legendSetting"
import ChartCommonOptionsSetting from "toolbarComponents/bigScreen/common/chart-common-options-setting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
import PictorialBarSeriesSetting from "toolbarComponents/bigScreen/common/options/seriesSetting/pictorialBarSeriesSetting"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
import scrollSetting from "toolbarComponents/bigScreen/common/options/scrollSetting"
import numberSetting from "toolbarComponents/bigScreen/common/options/numberSetting"

import publicData from "toolbarComponents/bigScreen/common/options/publicData"
// 引入默认折线图样式
import { chartOption1 } from "materials/bigScreen/line/menus/difference_options/allTypeCharOptions/chartOption1"

export default {
  name: "pictorialBar-options-setting",
  components: {
    ChartCommonOptionsSetting,
    ChartCommonOptionsSetting1,
    PictorialBarSeriesSetting,
    controlWidthAndSizeAndZindex,
    legendSetting,
    scrollSetting,
    numberSetting
  },
  mixins: [publicData],
  props: {
    options: Object
  },
  data() {
    return {
      this1: this,
      sizeActiveNames: ["1", "2", "3"],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      tabsActive: 0, //  显示数据组还是图例
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      singleColorDefault: "rgba(0, 71, 255, 1)",
      multiColorDefault: {
        startColor: "#5A81FF",
        endColor: "#4BDFFF"
      },
      collapseDataActiveNames: [],
    }
  },
  watch: {
    seriesData: {
      handler(newVal, oldVal) {
        if (JSON.parse(JSON.stringify(newVal)) !== JSON.parse(JSON.stringify(oldVal))) this.init()
      },
      deep: true
    }
  },
  created() {
    this.init()
  },

  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    // 动态数据
    seriesData: {
      get() {
        console.log('series', this.options.chartOption.series[0].type[0])
        if (this.options.chartOption.series) {
          // console.log(this.options.chartOption.series)
          return this.options.chartOption.series
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption", false)
      }
    },
  },
  methods: {
    init() {
      this.options.chartOption.series.forEach(item => {
        this.collapse[item.name] = {
          isActive: false,
          shape_isActive: false,
          text_isActive: false
        }
      })
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        if (val == "8") {
          return
        }
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    // 抽屉展开收起方法
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    },
  }
}
</script>

<style scoped>
.color-picker-container .color-text {
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
  color: inherit;
  font-size: 12px;
  max-width: 80%;
}

.bar-options-setting-dialog /deep/ .el-collapse-item__header {
  height: auto;
}
</style>
<style>
.bar-options-setting-dialog .tabs .tabs-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 34px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  margin-right: 24px;
}
.bar-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
.bar-options-setting-dialog .tabs.home_tabs .tabs-item {
  color: rgba(0, 0, 0, 0.6);
}
.bar-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
</style>
